import { useEffect, useState, useRef } from "react";
import { AxiosResponse, AxiosError } from "axios";

import axiosInstance from "./axiosInstance";

const useApi = <T>(
  url: string,
  method: string,
  payload: {},
  requiredAuth: boolean = false,
) => {
  const [data, setData] = useState<any | null>(null);
  const [error, setError] = useState<AxiosError>();
  const [loaded, setLoaded] = useState(false);

  const controllerRef = useRef(new AbortController());
  const cancel = () => {
    controllerRef.current.abort();
  };

  useEffect(() => {
    (async () => {
      try {
        let tokenResponse: any = null;

        if (requiredAuth) {
          tokenResponse = await axiosInstance.request({
            data: {
              platform_code: import.meta.env.VITE_PLATFORM_CODE,
            },
            method: "POST",
            url: "/api/request-access",
          });
        }

        if (
          requiredAuth == true &&
          tokenResponse &&
          tokenResponse.data.status == true
        ) {
          axiosInstance.defaults.headers.common["Auth-Api-Key"] =
            tokenResponse.data.response.access_code;
        }

        const response: AxiosResponse<T> = await axiosInstance.request({
          data: payload,
          signal: controllerRef.current.signal,
          method,
          url,
        });

        setData(response.data);
      } catch (error: any) {
        setError(error);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  return { data, error, loaded, cancel };
};

export default useApi;
